import {
  Header1,
  Instruction,
  InstructionWithButtonGroup,
  InstructionWithTextarea,
} from "../../BlockComponent";
import { LastCard } from "../common";

export const Content_0_8_A = [
  Instruction("typography_0_0_0"),
  Header1("typography_1_0_0"),
  InstructionWithTextarea("typography_2_0_0"),
  InstructionWithTextarea("typography_3_0_0"),
  InstructionWithTextarea("typography_4_0_0"),

  InstructionWithButtonGroup("typography_5_0_0", [
    {
      translationKey: "네",
      showFromId: "진료 중",
      hideFromId: "진료 중 아님",
    },
    {
      translationKey: "아니요",
      showFromId: "진료 중 아님",
      hideFromId: "진료 중",
    },
  ]),

  InstructionWithTextarea(`typography_8_0_0`, undefined, {
    blockId: "진료 중 아님",
    nextBlockId: "동의서",
  }),

  InstructionWithTextarea(`typography_6_0_0`, undefined, {
    blockId: "진료 중",
  }),

  InstructionWithButtonGroup(
    `typography_7_0_0`,
    [
      {
        translationKey: "네",
      },
      {
        translationKey: "아니요",
      },
    ],
    undefined,
    { blockId: "진료 중" }
  ),

  Header1("typography_9_0_0", { blockId: "동의서" }),
  Instruction("typography_10_0_0"),

  InstructionWithButtonGroup(
    `typography_11_0_0`,
    [
      {
        translationKey: "동의해요",
        showFromId: "동의",
        hideFromId: "비동의",
      },
      {
        translationKey: "동의하지 못해요",
        showFromId: "비동의",
        hideFromId: "동의",
      },
    ],
    undefined,
    { blockId: "동의 1" }
  ),

  InstructionWithButtonGroup(
    `typography_12_0_0`,
    [
      {
        translationKey: "동의해요",
        showFromId: "동의",
        hideFromId: "비동의",
      },
      {
        translationKey: "동의하지 못해요",
        showFromId: "비동의",
        hideFromId: "동의",
      },
    ],
    undefined,
    { blockId: "동의 2" }
  ),

  InstructionWithButtonGroup(
    `typography_13_0_0`,
    [
      {
        translationKey: "동의해요",
        showFromId: "동의",
        hideFromId: "비동의",
      },
      {
        translationKey: "동의하지 못해요",
        showFromId: "비동의",
        hideFromId: "동의",
      },
    ],
    undefined,
    { blockId: "동의 3" }
  ),

  Instruction("typography_14_0_0"),

  ...LastCard,
];